import React from "react";
import { DropdownItem, Badge } from "reactstrap";
import style from "./../style.module.scss";
import { DateTime, Icon } from "../UI";
import classnames from "classnames";
import { FormattedDate, FormattedTime } from "react-intl";
import { localDateTime } from "../../../utils/Helper";

const Item = ({ item, header, toggleModal, setRead }) => {
  const processed = item.processedBy != "";

  const handleOnClick = () => {
    toggleModal({ authorization: item });

    if (processed) {
      handleRead({ id: item.id });
    }
  };

  const handleRead = ({ id }) => setRead({ id });
  const authIsForLater = a => a.processDate && localDateTime(a.processDate) > new Date(); 

  return (
    <DropdownItem tag="div" onClick={() => handleOnClick()} className={classnames(style.item, {})}>
      <div className={style.icon}>
        <Icon processed={processed} authorized={item.authorized} />
      </div>
      <div className={style.body}>
        <div className={style.top}>
          <span className={style.process}>
            {item.process} #{item.processId}
          </span>
          <span className="text-muted d-flex">
            <div>
              <FormattedDate value={localDateTime(item.dateTime)} />{" "}
              <FormattedTime value={localDateTime(item.dateTime)} hour12={false} />
            </div>
            <span className={style.pin}>
              {header === "unread" ? (
                <i className="fa fa-times" aria-hidden="true" onClick={() => handleRead({ id: item.id })}></i>
              ) : (
                <i className="fa fa-thumb-tack" aria-hidden="true"></i>
              )}
            </span>
          </span>
        </div>
        <p>{item.text}</p>
        {item.description !== "" && <p>{item.description}</p>}
        {item.isFromOffer && (
          <span style={{ marginLeft: 5 }} >
            <i className="fa fa-shopping-cart text-muted" />
            {authIsForLater(item) && <Badge color="yellow" className="ml-1 mr-1">NOT TODAY</Badge>}
          </span>
        )}
        {item.hasProcessDate && (
          <div className="text-muted" style={{ fontSize: 12 }}>
            Process Date: <DateTime date={item.processDate} />
          </div>
        )}
      </div>
    </DropdownItem>
  );
};

export default Item;
